import React, { useEffect, useState } from 'react';
import { get, random } from 'lodash';
import { Loader, Card } from 'components';
import { useRouteMatch } from 'react-router-dom';
import { useSelect, useAction } from 'hooks';
import ApplicationForm from './ApplicationForm';

const ResubmitApplicationForm = () => {
  const { params } = useRouteMatch()
  
  // const history = useHistory()
  const [isReady, setIsReady] = useState(false)
  const getSelected = useAction('payment.view')
  const show = useAction('payment.show')
  const showOwnershipType = useAction('ownershipType.show')
  const showTransactionType = useAction('transactionType.show')
  const selectedPayment = useSelect('payment.selected', { id: params.id })
  
  const selectedApplication = useSelect('application.selected', { id: get(selectedPayment, 'relationships.module.data.id') });
  const selectedOwnershipType = useSelect('ownershipType.selected', { id: get(selectedApplication, 'attributes.ownership_type_id') });
  
  const selectedIndividual =  useSelect('application.selectedIndividual', { id: get(selectedPayment, 'relationships.moduleDetail.data.id') })
  const selectedNonIndividual =  useSelect('application.selectedNonIndividual', { id: get(selectedPayment, 'relationships.moduleDetail.data.id') })

  const listServiceUnits = useSelect('application.listServiceUnits')
  const listExistingFranchise = useSelect('application.listExsitingFranchise')
  const listAuthorizedDrivers = useSelect('application.listAuthorizedDrivers')
  const listRequirements = useSelect('application.selectedRequirementsArrayByPaymentId', { payment_id: params.id })
  
  const selectedPaymentTranscation = useSelect('application.paymentTransctionTypeIdsByPaymentId', { id: params.id });
  const selectedTransactionType = useSelect('transactionType.transactionTypeByIds', { ids: selectedPaymentTranscation });
  

  const showing = useSelect('loading.isLoading', { type: 'payment.view' })
  

  const getModuleDetail = () => {
    if(+get(selectedOwnershipType, 'id') === 1){
      return get(selectedIndividual, 'attributes')
    }
    if([2,3,4].indexOf(+get(selectedOwnershipType, 'id')) > -1){
      return get(selectedNonIndividual, 'attributes') 
    }
  }
  

  useEffect(() => {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }, [])

  useEffect(() => {
    
    if(selectedTransactionType){
      
      localStorage.setItem('app_transaction', JSON.stringify({
        transaction_kind: selectedTransactionType.length > 1 ? 2 : 1,
        transaction_type_id: 1,
        transaction_type_multiple: [],
        ownership_type_id: +get(selectedOwnershipType, 'id'),
        payment_id: ''
      }))


      localStorage.setItem('app_data', JSON.stringify({
        ...getModuleDetail(),
        ...get(selectedApplication, 'attributes'),
        route_id:`${get(selectedApplication, 'attributes.route')}`,
        is_others: get(selectedApplication, 'attributes.route_other') ? 1 : 0,
        service_units: Object.values(listServiceUnits).map(x => ({...get(x, 'attributes'), id: random(1, 1000)})),
        existing_franchises: Object.values(listExistingFranchise).map(x => ({...get(x, 'attributes'), id: random(1, 1000)})),
        authorized_drivers: Object.values(listAuthorizedDrivers).map(x => ({...get(x, 'attributes'), id: random(1, 1000)})),
        application_requirements: Object.values(listRequirements).map(x => get(x, 'attributes')),
        application_promise: 1
      }))

      localStorage.setItem('app_tab', 0)

      setIsReady(true)
    }
    // eslint-disable-next-line
  }, [selectedTransactionType])

  useEffect(() => {
    
    show(params.id)
    getSelected(params.id)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    showOwnershipType(get(selectedApplication, 'attributes.ownership_type_id'))
    // eslint-disable-next-line
  }, [get(selectedApplication, 'attributes.ownership_type_id')])

  useEffect(() => {
    showTransactionType(get(selectedPayment, 'attributes.transaction_type_id'))
    // eslint-disable-next-line
  }, [get(selectedPayment, 'attributes.transaction_type_id')])
  
  // const handleBack = e => {
  //   e.preventDefault()
  //   history.push('/')
  // }

  return (
    <>
      {showing && 
        <Card>
          <Card.Body>
            <Loader.Table />
          </Card.Body>
        </Card>
      }
      
      {!showing && isReady && <ApplicationForm method="update" />}
    </>
    
  )
}

export default ResubmitApplicationForm